import { DateHelpers } from '@crm/shared/lib';

export const formatDealDateBadge = (date: string, todayLabel?: string) => {
    const dealDate = new Date(date);

    if (DateHelpers.isSameLocalDate(dealDate, new Date())) {
        return todayLabel ?? DateHelpers.formatCompactDisplayDate(dealDate);
    }

    return DateHelpers.formatDisplayDate(dealDate, 'dd.MM.yyyy');
};
